export default {
    flash(message, type = 'success') {
        this.$root.$emit('flash', { message, type })
        this.scrollToTop()
    }
}